<template>
	<div class="mb-4">
		<div class="section-title" v-if="title !== null" :style="getStyle(node)">
			{{ title.contact || '' }}
		</div>
		<div class="" v-for="(field, index) in fields" :key="index">
			<field
				v-if="field.enabled"
				v-model="value[field.name]"
				:loading="isLoading"
				:name="field.name"
				:field="field.field"
				:type="field.type"
				:options="setOptions(field)"
				:optionConfig="setOptionConfig(field)"
				:label="field.label"
				:placeholder="field.placeholder"
				:required="field.required"
				:isValid.sync="field.is_valid">
			</field>
		</div>
	</div>
</template>

<script>
// import shippingApi from '@/api/shipping';
import { getNodeStyle } from '@/lib/helper';
import Field from './Field.vue';

// eslint-disable-next-line
const formattedOptions = array => array.map((curr) => {
	return {
		value: curr,
		label: curr,
	};
});

/**
 * src https://stackoverflow.com/questions/22476258/create-an-array-with-all-numbers-from-min-to-max-without-a-loop
 */
// eslint-disable-next-line
const createArrFromMinMax = (min, max) => Array.apply(null, { length: max + 1 })
	.map(Number.call, Number)
	.slice(min);

export default {
	name: 'Contact',
	components: {
		Field,
	},
	props: {
		node: {
			type: Object,
		},
		title: {
			type: Object,
			default: null,
		},
		fields: {
			type: Array,
			default: () => [],
		},
		provinces: {
			type: Array,
			default: () => [],
		},
		isMultipleVarian: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isLoading: false,
			value: {},
			cities: [],
			districts: [],
			completeDistricts: [],
		};
	},
	computed: {},
	watch: {},
	methods: {
		// set options for input type selecth
		setOptions(field) {
			// console.log('field: ', field);
			let options = field?.options?.length > 0
				? formattedOptions(field.options)
				: field.options;

			if (field.name === 'quantity') {
				const min = field.value?.min;
				const max = field.value?.max;

				const numbers = createArrFromMinMax(min, max);
				// options = formattedOptions(numbers);
				options = numbers;
			} else if (field.name === 'province') {
				options = this.provinces;
			} else if (field.name === 'city') {
				options = this.cities;
			} else if (field.name === 'district') {
				options = this.districts;
			} else if (field.name === 'complete_district') {
				options = this.completeDistricts;
			}

			return options;
		},

		setOptionConfig(field) {
			const config = {
				searchable: true,
				close_on_select: true,
				show_labels: false,
				internal_search: true,
				clear_on_select: true,
				preselect_first: false,
			};

			if (field.name === 'province') {
				config.trackby = 'label';
				config.name = 'label';
				config.trackby = 'text';
				config.name = 'text';
				config.show_labels = false;
			} else if (field.name === 'city') {
				config.trackby = 'label';
				config.name = 'label';
				config.trackby = 'city_name_with_type';
				config.name = 'city_name_with_type';
			} else if (field.name === 'district') {
				config.trackby = 'label';
				config.name = 'label';
				config.trackby = 'subdistrict_name';
				config.name = 'subdistrict_name';
			} else if (field.name === 'complete_district') {
				config.trackby = 'label';
				config.name = 'label';
				config.trackby = 'subdistrict_name';
				config.name = 'subdistrict_name';
				config.internal_search = false;
				// config.clear_on_select = false;
			} else if (field.name === 'quantity') {
				config.preselect_first = true;
			}

			return config;
		},

		getStyle({ options }) {
			const styles = [
				'text-color',
			];
			const style = getNodeStyle(options, styles);
			return style;
		},
	},
};
</script>

<style>

</style>
